export const paramsKey = params => JSON.stringify(
  Object.keys(params || {}).sort().map(key => [key, String(params[key])])
)

export const listParamsKey = params => {
  const { page, per_page, ...rest } = params || {}
  return paramsKey(rest)
}
